'use client';
// app/providers.js
import { Suspense, useEffect } from 'react';

import { usePathname, useSearchParams } from 'next/navigation';

import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

if (typeof window !== 'undefined') {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_API_KEY ?? 'MISSING KEY', {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
  });
}

function PostHogPageview() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (pathname) {
      let url = window.origin + pathname;

      if (searchParams?.toString()) {
        url = `${url}?${searchParams.toString()}`;
      }
      posthog.capture('$pageview', {
        $current_url: url,
      });
    }
  }, [pathname, searchParams]);

  return <></>;
}

export function PHProvider({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Suspense>
        <PostHogPageview />
      </Suspense>
      <PostHogProvider client={posthog}>{children}</PostHogProvider>
    </>
  );
}

export default posthog;
